import { render, staticRenderFns } from "./UnsplashPicker.vue?vue&type=template&id=6c64b475&scoped=true"
import script from "./UnsplashPicker.vue?vue&type=script&lang=js"
export * from "./UnsplashPicker.vue?vue&type=script&lang=js"
import style0 from "./UnsplashPicker.vue?vue&type=style&index=0&id=6c64b475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c64b475",
  null
  
)

export default component.exports